<template>
	<!-- <div :style="scaleStyle"> -->
	<div id="app" :style="_isMobile ? 'min-width:0;overflow:hidden' : ''">
		<div class="navBox" v-if="isLogin && !_isMobile && !isHome">
			<div class="nav" :style="navStyle" :class="{ fullScreen: !showTop }">
				<!-- <img class="logo" src="./assets/image/gs_logo.jpg" @click="goHome" /> -->
				<div class="center-box" :style="getCardTextStyle" @click="goHome"> <span style="margin-right: 10px;">
					</span>
					<span style="cursor: pointer;"> {{
						titleText }}</span>
				</div>
				<div class="rightContent" ref="rightContent">
					<img src="./assets/image/cIcon5.png" @click="goHome" v-if="showHome"
						style="margin-right: 16px; cursor: pointer;" alt />
					<div class="bottom">
						<div class="manage">
							<Dropdown transfer @on-click="userAction">
								<div class="manage" style="max-width: 120px;overflow: hidden;"
									href="javascript:void(0)">
									<img class="manageIcon" v-if="user.userLogo" :src="user.userLogo" alt />
									<!-- <img class="manageIcon" v-else src="./assets/image/userLogo.png" alt /> -->
									<img class="manageIcon" v-else :src="getUserLogo()" alt />
									<!-- <img class="manageIcon" v-else :src="cachedConfig.innerPageConfig.myIconImage" alt /> -->

									<Icon type="ios-arrow-down"></Icon>
								</div>
								<DropdownMenu slot="list">
									<DropdownItem name="center">我的</DropdownItem>
									<!-- <DropdownItem name="reset">修改密码</DropdownItem> -->
									<DropdownItem name="loginout">退出</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>

					</div>
				</div>
			</div>

		</div>



		<div class="content" :style="contentStyle">
			<router-view />
		</div>
		<!-- <tool></tool> -->
		<timeModal :time="12"></timeModal>
		<!-- <adviceModal></adviceModal> -->
		<!-- <reAdviceModal></reAdviceModal> -->
		<!-- <showYijianModal></showYijianModal> -->
		<!-- <showYapinModal></showYapinModal> -->
		<!-- 账号到期提醒组件，只在非登录页显示 -->
		<!-- <AccountExpireNotice  /> -->
		<!-- 时间	{{ customerAccountEndDate }} -->
		<AccountExpireNotice v-if="isLogin && $route.path !== '/login'" />
		<!-- 红色文字提示，只在首页、估价系统页面、我的页面显示 -->
		<!-- <div v-if="shouldShowRedText && expireNoticeText" class="expire-notice-text">
			{{ expireNoticeText }}
		</div> -->
		<!-- <div  class="expire-notice-text">
			【短信签名】温馨提醒：您的账号还有XX天到期
		</div> -->
	</div>


</template>
<script>
// import tool from "@/components/Tools.vue";
import timeModal from "@/components/modal/timeModal.vue";
import adviceModal from "@/components/modal/adviceModal.vue";
import reAdviceModal from "@/components/modal/reAdviceModal.vue";
// import showYijianModal from "@/components/modal/showYijianModal.vue";
// import showYapinModal from "@/components/modal/showYapinModal.vue";
import AccountExpireNotice from "@/components/AccountExpireNotice.vue";
import store from '@/store';

// import {getSingleSelectProvince} from './api/dataQuery';
import {
	getObj,
	loginout,
	resetPwd,
	appdetail,
	openConfig
} from "@/api/user/user";
import { setAppConfig, getLocalAppConfig, getConfigItem } from "@/utils/appConfig";
import { getAuthCityNew } from '@/api/city';
import { getDetail } from "@/api/MyAccount";

import {
	get_model_tree
} from "@/api/router";
import {
	getUnreadInfo,
	getSysUnreadInfo
} from "@/api/infoManage";
import {
	mapMutations,
	mapState
} from "vuex";
import dataReports from "@/mixins/dataReports";
import accountExpireMixin from "@/mixins/accountExpireMixin";
export default {
	name: "app",
	components: {
		// tool,
		timeModal,
		// adviceModal,
		// showYijianModal,
		// showYapinModal,
		// reAdviceModal
		AccountExpireNotice,
	},
	mixins: [dataReports, accountExpireMixin],
	computed: {
		...mapState([
			"userId",
			"user",
			"fixedLeft",
			"customerAccountEndDate",
			"resourceAuthIds"
		]),
		scaleStyle() {
			return {
				transform: `scale(${this.scale})`,
				transformOrigin: 'top left',
				width: `${100 / this.scale}%`,
				height: `${100 / this.scale}%`,
			};
		},
		titleText() {
			let path = this.$route.path;
			const containsPersonalCenter = path.includes('PersonalCenter'); // 判断是否包含PersonalCenter
			if (containsPersonalCenter) {
				return ' AI估价系统';
			} else {
				const cachedConfig = getLocalAppConfig();
				if (!cachedConfig) {
					return 'AI估价系统';
				}
				return cachedConfig.sysValuationConfig.name || 'AI估价';
			}
		},
		isLogin() {
			return this.$store.state.token && this.$store.state.userId;
		},
		isHome() {
			return this.$route.path == "/home";
		},

		_isMobile() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			);
			return !!flag;
		},
		isInfoNum() {
			let str = '99+'
			return this.infoNum < 100 ? this.infoNum : str
		},
		navStyle() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return {};
			}
			const style = {};
			style.backgroundColor = cachedConfig.innerPageConfig.topBarColor;
			return style;
		},
		getCardTextStyle() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return {};
			}
			const style = {};

			let path = this.$route.path;
			const containsPersonalCenter = path.includes('PersonalCenter'); // 判断是否包含PersonalCenter
			if (containsPersonalCenter) {
				return style;
			} else {
				style.color = cachedConfig.sysValuationConfig.color;
			}

			return style;
		},
		contentStyle() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return {};
			}
			const style = {};
			const innerPageConfig = cachedConfig.innerPageConfig;
			if (innerPageConfig.bgType === 'custom') {
				// 如果配置为custom且有自定义背景图片，使用自定义背景
				style.backgroundImage = `url(${innerPageConfig.bgImage})`;

			}
			return style;
		},
		showHome() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return true;
			}
			if (cachedConfig.homePage === 'true') {
				return true
			} else {
				return false
			}
		},

	},
	data() {
		return {
			showTop: true,
			scale: 1,
			infoNum: 0,
			navList: [{
				icon: require("./assets/image/homeW.png"),
				iconB: require("./assets/image/homeB.png"),
				path: "/",
				pathName: "首页",
			},
			{
				icon: require("./assets/image/DepthStudyW.png"),
				iconB: require("./assets/image/DepthStudyB.png"),
				// path: "/Empowerment/pledge/houseProperty/rapidValuation",
				path: "/Empowerment",
				pathName: "房屋智能估价",
				// childrenRoute: [
				// 	{
				// 		icon: require("./assets/image/cIcon2.png"),
				// 		iconB: require("./assets/image/cIcon2B.png"),

				// 		path: "/Empowerment/pledge/houseProperty/rapidValuation",
				// 		pathName: "房屋智能估价",
				// 	},
				// ],
			},
			{
				icon: require("./assets/image/DepthStudyW.png"),
				iconB: require("./assets/image/DepthStudyB.png"),
				path: "/dataIframe",
				pathName: "数据服务",
			},
			// {
			// 	icon: require("./assets/image/EmpowermentW.png"),
			// 	iconB: require("./assets/image/EmpowermentB.png"),
			// 	path: "/Empowerment",
			// 	pathName: "大数据赋能",
			// 	childrenRoute: [
			// 		{
			// 			icon: require("./assets/image/cIcon2.png"),
			// 			iconB: require("./assets/image/cIcon2B.png"),

			// 			path: "/Empowerment/pledge/houseProperty/rapidValuation",
			// 			pathName: "房屋智能估价",
			// 		},
			// 		{
			// 			icon: require("./assets/image/cIcon1.png"),
			// 			iconB: require("./assets/image/cIcon1B.png"),
			// 			path: "/Empowerment/Analysis/Home",
			// 			pathName: "一键看项目",
			// 		},

			// 	],
			// },
			{
				icon: require("./assets/image/InsightW.png"),
				iconB: require("./assets/image/InsightB.png"),
				path: "/Insight",
				pathName: "数据洞察",
				childrenRoute: [
					{
						icon: require("./assets/image/cIcon4.png"),
						iconB: require("./assets/image/cIcon4B.png"),
						path: "/Insight/City",
						pathName: "城市系统",
						modalName: "城市模块",
					},
					{
						icon: require("./assets/image/cIcon5.png"),
						iconB: require("./assets/image/cIcon5B.png"),
						path: "/Insight/enterprise",
						pathName: "企业监测",
						modalName: "企业模块",
					},
					{
						icon: require("./assets/image/cIcon2.png"),
						iconB: require("./assets/image/cIcon2B.png"),
						// path: _this.resourceAuthIds.includes(9)? "/Insight/PlaceMarket" :"/Insight/PlaceSearch",
						path: "/Insight/land",
						pathName: "土地市场",
						modalName: "土地模块",
					},
					{
						icon: require("./assets/image/cIcon3.png"),
						iconB: require("./assets/image/cIcon3B.png"),
						path: "/Insight/financialMarket",
						pathName: "金融市场",
						modalName: "金融模块",
					},
					{
						icon: require("./assets/image/cIcon1.png"),
						iconB: require("./assets/image/cIcon1B.png"),
						path: "/Insight/MacroEconomy",
						pathName: "宏观经济",
						modalName: "宏观模块",
					},




					// {
					// 	icon: require("./assets/image/cIcon6.png"),
					// 	iconB: require("./assets/image/cIcon6B.png"),
					// 	path: "/Insight/publicSentiment",
					// 	pathName: "舆情监测",
					// },
				],
			},

			// {
			//   icon: require("./assets/image/ExcavateW.png"),
			//   iconB: require("./assets/image/ExcavateB.png"),
			//   //path: "/Excavate",
			//   path: "",
			//   pathName: "数据挖掘",
			// },
			{
				icon: require("./assets/image/DepthStudyW.png"),
				iconB: require("./assets/image/DepthStudyB.png"),
				path: "/Research",
				pathName: "常规报告",
			},


			{
				icon: require("./assets/image/DepthStudyW.png"),
				iconB: require("./assets/image/DepthStudyB.png"),
				path: "/WarnResearch",
				pathName: "市场监测与预警报告",
			},
			// {
			// 	icon: require("./assets/image/CustomizedServiceW.png"),
			// 	iconB: require("./assets/image/CustomizedServiceB.png"),
			// 	path: "/customerorder",
			// 	pathName: "定制化",
			// },
			{
				icon: require("./assets/image/CustomizedServiceW.png"),
				iconB: require("./assets/image/CustomizedServiceB.png"),
				path: "https://address.zhongsituo.com:10444/shareScreen/eyJzY3JlZW5JZCI6OX0=",
				alink: true,
				pathName: "数据确权可视化",
			},
				// {
				//   icon: require("./assets/image/IntelligenceW.png"),
				//   iconB: require("./assets/image/IntelligenceB.png"),
				//   //path: "/Intelligence",
				//   path: "",
				//   pathName: "商务智能",
				// },
			],
			userLogoSrc: './assets/image/userLogo.png',
			childrenRoute: [],
			showChildren: false,
			showChildrenIndex: -1,
			showModal: false,
			formItem: {
				psw: "",
			},
			loading: false,
			ele: "",
			screenWidth: null,
		};
	},

	created() {
		this.init()

	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {

		window.addEventListener('resize', this.handleResize);
		this.handleResize(); // 初始化时调用一次


		if (this.$router.history.current.path !== "/login") {
			setInterval(() => {
				this.getNumber()
			}, 60000)
		}
		if (this.$route.path != '/login') {
			this.getUserInfo()
		}
		this.getNumber()
		this.screenWidth = document.body.clientWidth
		window.onresize = () => {
			//屏幕尺寸变化
			return (() => {
				this.screenWidth = document.body.clientWidth
			})()
		}

		this.$nextTick(() => {
			var that = this
			// var ele = document.removeEventListener('click',(e)=>{this.btnSysLog(e)})
			setTimeout(function () {
				var ele = window.addEventListener('click', (e) => { that.btnSysLog(e) })
				// that.ele = ele
			}, 500)
		})

	},
	destroyed() {
		window.removeEventListener('click', (e) => { this.btnSysLog(e) })
	},
	watch: {
		$route() {
			if ((store.state.token && store.state.userId)) {//当用户登陆后
				this.getNumber()
			}
			//
		},
		screenWidth: function (n, o) {
			// if (n <= 1400) {
			// 	this.changeState({
			// 		prop: "showLeft",
			// 		value: false,
			// 	});
			// } else {
			// 	this.changeState({
			// 		prop: "showLeft",
			// 		value: true,
			// 	});
			// }
		}

		//获取页面宽度


	},

	methods: {
		...mapMutations(["changeState"]),
		//鼠标移入的时候，显示左侧导航栏
		handleResize() {
			const scale = window.innerWidth / 1920; // 假设设计稿宽度为1920px
			let innerWidth = window.innerWidth;

			if (innerWidth < 1400) {
				this.changeState({
					prop: "showLeft",
					value: false,
				});

			} else {
				this.changeState({
					prop: "showLeft",
					value: true,
				});

			}


			this.scale = scale;
		},
		async init() {
			this.getAppConfig();//获取应用配置
			await this.$store.dispatch("getcityList");//获取城市列表
			await this.$store.dispatch("getQueryCityLatLngList");//获取城市列表
			this.getAuthCityList();//获取权限城市列表
		},
		// 封装更新 favicon 的方法
		updateFavicon(url) {
			// 获取已定义的 link 标签
			let link = document.getElementById('dynamicFavicon');

			// 如果不存在，则创建一个新的 link 标签
			if (!link) {
				link = document.createElement('link');
				link.id = 'dynamicFavicon';
				link.rel = 'icon';
				link.type = 'image/x-icon'; // 根据实际图标类型调整（如 image/png）
				document.head.appendChild(link);
			}

			// 关键：更新 href（添加时间戳避免缓存）
			link.href = `${url}?t=${new Date().getTime()}`;
		},
		getUserLogo() {
			const cachedConfig = getLocalAppConfig();
			if (!cachedConfig) {
				return require('./assets/image/userLogo.png');
			}
			if (cachedConfig.innerPageConfig.myIconType === "custom") {
				return cachedConfig.innerPageConfig.myIconImage
			} else {
				return require('./assets/image/userLogo.png');

			}
		},

		goHome() {
			this.$router.push({
				path: "/",
			})
		},
		goDataIframe() {
			this.$router.push({
				path: "/dataIframe",
			})
		},
		getAuthCityList() {
			let params = {
				origin: 1,//1数据平添
				// userId: this.$store.state.userId
			}
			getAuthCityNew(params).then((res) => {
				this.$store.dispatch("getUserCityList", res);//获取用户城市列表
				//存入本地缓存
			});
		},
		// 获取应用配置
		getAppConfig() {
			let params = {
				loginUrl: window.location.origin,

			}
			openConfig(params).then((res) => {
				let obj = res.records[0]
				obj.homePageConfig = JSON.parse(obj.homePageConfig)
				obj.loginPageConfig = JSON.parse(obj.loginPageConfig)
				obj.sysSignConfig = JSON.parse(obj.sysSignConfig)
				obj.sysValuationConfig = JSON.parse(obj.sysValuationConfig)
				obj.sysDateConfig = JSON.parse(obj.sysDateConfig)
				obj.innerPageConfig = JSON.parse(obj.innerPageConfig)
				obj.sysNameConfig = JSON.parse(obj.sysNameConfig)
				if (obj) {
					// 添加更新时间戳
					const configWithTime = {
						...obj,
						updateTime: new Date().toISOString()
					};
					// 使用工具函数存储配置
					setAppConfig(configWithTime);
					this.updateFavicon(obj.sysSignConfig.tabImage);
				}

			}).catch((error) => {


				// let obj = {
				// 	"apiPrefix": "",
				// 	"createBy": "zoucheng",
				// 	"createById": 1034,
				// 	"createTime": "2025-11-06 17:06:10",
				// 	"createTimeEnd": "",
				// 	"createTimeStart": "",
				// 	"current": 1,
				// 	"customerId": "17448786387",
				// 	"distributorUserName": "中思拓研究院test000",
				// 	"extra": "{\"smsAccount\":\"333\",\"signature\":\"\",\"smsPassword\":\"222\"}",
				// 	"frontend": "",
				// 	"homePage": "true",
				// 	"homePageConfig": "{\"bgType\":\"default\",\"bgImage\":\"\"}",
				// 	"id": 15,
				// 	"innerPage": "",
				// 	"innerPageConfig": "{\"bgType\":\"default\",\"myIconType\":\"default\",\"topBarColor\":\"#D4E6F7\",\"myIconImage\":\"http://data.zstnb.cn/group1/M00/00/29/wKgDKWkRprOAb9dUABCiCdjtlUc7881160?filename=%E7%94%9F%E6%88%90+JPG+%E9%A1%B5%E7%AD%BE%E5%9B%BE+%281%29.png\",\"bgImage\":\"http://data.zstnb.cn/group1/M00/00/29/wKgDKWkRpp6APQb1ABz-gZzU8o82346167?filename=%E7%94%9F%E6%88%90+JPG+%E9%A1%B5%E7%AD%BE%E5%9B%BE+%284%29.png\"}",
				// 	"loginPage": "",
				// 	"loginPageConfig": "{\"bgType\":\"default\",\"wanganIcpUrl\":\"https://beian.mps.gov.cn/#/query/webSearch\",\"icp\":\"琼ICP备2025060203号\",\"wanganIcp\":\"琼公网安备46902802000140号\",\"position\":\"right\",\"bgImage\":\"http://data.zstnb.cn/group1/M00/00/29/wKgDKWkRmqeABo88ABq6cBXoGzQ2546489?filename=%E7%94%9F%E6%88%90+JPG+%E9%A1%B5%E7%AD%BE%E5%9B%BE+%282%29.png\",\"icpUrl\":\"https://beian.miit.gov.cn/#/Integrated/index\",\"loginMethods\":[\"account\"]}",
				// 	"loginPageLoginType": "",
				// 	"loginUrl": "http://admin.zstnb.cn:8080",
				// 	"msgId": null,
				// 	"size": 10,
				// 	"sysDate": "true",
				// 	"sysDateConfig": "{\"nameBgImage\":\"\",\"color\":\"#fff\",\"iconImage\":\"\",\"iconType\":\"default\",\"name\":\"数据服务\",\"style\":\"blue\",\"position\":\"right\",\"nameBgType\":\"default\"}",
				// 	"sysName": "AI估价系统",
				// 	"sysNameConfig": "{\"color\":\"#002C63\",\"position\":\"left\"}",
				// 	"sysSign": "",
				// 	"sysSignConfig": "{\"tabImage\":\"http://data.zstnb.cn/group1/M00/00/29/wKgDKWkS9BeAYYEuAAJax9Xacag4157565?filename=%E9%A1%B5%E7%AD%BElogo.png\",\"color\":\"#002C63\",\"position\":\"right\"}",
				// 	"sysValuation": "true",
				// 	"sysValuationConfig": "{\"nameBgImage\":\"\",\"color\":\"#fff\",\"iconImage\":\"\",\"iconType\":\"default\",\"name\":\"AI估价\",\"style\":\"blue\",\"position\":\"left\",\"nameBgType\":\"default\"}",
				// 	"tenantId": "",
				// 	"updateBy": "chaoguan1",
				// 	"updateTime": "2025-11-12 10:35:57",
				// 	"updateTimeEnd": "",
				// 	"updateTimeStart": "",
				// 	"watermark": "",
				// 	"watermarkConfig": ""
				// }
				// obj.homePageConfig = JSON.parse(obj.homePageConfig)
				// obj.loginPageConfig = JSON.parse(obj.loginPageConfig)
				// obj.sysSignConfig = JSON.parse(obj.sysSignConfig)
				// obj.sysValuationConfig = JSON.parse(obj.sysValuationConfig)
				// obj.sysDateConfig = JSON.parse(obj.sysDateConfig)
				// obj.innerPageConfig = JSON.parse(obj.innerPageConfig)
				// obj.sysNameConfig = JSON.parse(obj.sysNameConfig)
				// if (obj) {
				// 	// 添加更新时间戳
				// 	const configWithTime = {
				// 		...obj,
				// 		updateTime: new Date().toISOString()
				// 	};
				// 	// 使用工具函数存储配置
				// 	setAppConfig(configWithTime);
				// 	this.updateFavicon(obj.sysSignConfig.tabImage);
				// }

			});

		},
		getNumber() {
			let infoNum = 0;
			getUnreadInfo().then((res) => {
				infoNum = res;
				getSysUnreadInfo().then((data) => {
					infoNum += data;
					this.infoNum = infoNum;
				});
			})
		},
		mousePoint(e) {
			if (this.fixedLeft) return;
			if (e.clientX < 20) {
				this.changeState({
					prop: "showLeft",
					value: true,
				});
			} else if (e.clientX > 240) {
				this.changeState({
					prop: "showLeft",
					value: false,
				});
			}
		},

		routerActive(item) {
			if (this.$route.path === "/") {
				return item.path === this.$route.path;
			}
			return (
				item.path !== "/" && item.path && this.$route.path.includes(item.path)
			);
		},

		showChildrenHandle(item, index) {
			if (!item.childrenRoute) {
				this.showChildren = false;
				this.showChildrenIndex = -1;
				return;
			}
			this.showChildrenIndex = index
			this.childrenRoute = item.childrenRoute;
			this.showChildren = true;
		},
		getUserInfo() {
			if (localStorage.getItem("userId")) {
				getObj({
					id: localStorage.getItem("userId"),
				}).then((res) => {
					this.changeState({
						prop: "user",
						value: res,
					});
				});
				// 调用 getDetail 接口获取准确的 customerAccountEndDate
				this.getAccountDetail();
			} else {
				// this.$router.push({
				// 	path: "/login",
				// });
			}
		},
		// 获取账号详情，更新 customerAccountEndDate
		getAccountDetail() {
			if (localStorage.getItem("userId")) {
				getDetail(this.userId).then((res) => {
					if (res && res.customerAccountEndDate) {
						this.changeState({
							prop: "customerAccountEndDate",
							value: res.customerAccountEndDate,
						});
					}
				}).catch((err) => {
				});
			}
		},
		//点击菜单栏时使一键以及押品的无权限页面消失
		closeModal() {
			this.changeState({
				prop: "showYijianModal",
				value: false,
			});
			this.changeState({
				prop: "showYapinModal",
				value: false,
			});
		},
		routePush(item) {
			if (item.alink) {
				window.open(item.path, "_blank");
				return
			}
			if (item.childrenRoute) return;
			this.$router.push(item.path);
			this.showChildren = false;
			this.closeModal();
			if (!item.path) {
				this.$msg.error({
					type: "noAuthority",
					code: 1007,
				});
			}
		},
		userAction(name) {
			const self = this;
			const action = {
				reset: () => {
					this.showModal = true;
				},
				loginout: () => {
					// self.leavePageLog().then((res) => {
					// });
					this.changeState({
						prop: "token",
						value: "",
					});
					localStorage.setItem("token", "");
					localStorage.setItem("isLogin", false);
					localStorage.setItem("userId", "");
					localStorage.setItem("customerInfo", "");
					window.location.reload();
				},
				center: () => {
					this.$router.push("/PersonalCenter");
				},
			};
			action[name]();
		},
		handleSetPsw() {
			if (!this.formItem.psw) return this.$msg.error({
				text: "请输入新密码"
			});
			resetPwd({
				id: this.userId,
				pwd: this.formItem.psw.trim(),
			}).then((res) => {
				this.$msg.success({
					text: "修改成功"
				});
				// this.$msg.success("修改成功");
				this.changeState({
					prop: "token",
					value: "",
				});
				localStorage.setItem("token", "");
				localStorage.setItem("isLogin", false);
				localStorage.setItem("userId", "");
				window.location.reload();
			});
		},
		cancelModalHandle() {
			this.formItem.psw = "";
		},
		tRoutePush(item) {
			this.closeModal();
			if (item.modalName) {
				this.changeState({
					prop: "actionRouter",
					value: [],
				});
				get_model_tree({
					modelName: item.modalName,
				}).then((res) => {
					let actionRouter = [];
					res.children.map((item) => {
						let i = {
							url: location.protocol + "//" + location.host + item.fineReportUrl,
							title: item.indexName,
							children: [],
							icon: "ios-eye",
						};
						if (item.children) {
							item.children.map((item) => {
								i.children.push({
									url: location.protocol +
										"//" +
										location.host +
										item.fineReportUrl,
									title: item.indexName,
									icon: "ios-eye",
								});
							});
						}
						actionRouter.push(i);
					});
					this.changeState({
						prop: "actionRouter",
						value: actionRouter,
					});
					localStorage.setItem("actionRouter", JSON.stringify(actionRouter));
					this.showChildren = false;
					if (res.children[0].fineReportUrl) {
						let prodsrc = 'data.zhongsituo.com'
						this.changeState({
							prop: "iframeUrl",
							value: location.protocol +
								"//" +
								prodsrc +
								res.children[0].fineReportUrl,
						});
						localStorage.setItem(
							"iframeUrl",
							location.protocol +
							"//" +
							prodsrc +
							res.children[0].fineReportUrl
						);
					} else {
						this.changeState({
							prop: "iframeUrl",
							value: "",
						});
						localStorage.setItem("iframeUrl", "");
					}
					this.$router.push(item.path);
				});
			} else {
				this.changeState({
					prop: "actionRouter",
					value: "",
				});
				localStorage.setItem("actionRouter", "");
				this.changeState({
					prop: "iframeUrl",
					value: "",
				});
				localStorage.setItem("iframeUrl", "");
				this.showChildren = false;
				this.$router.push({ path: item.path, replace: true });
			}
		},

		//btnSysLog
		btnSysLog(e) {
			let parentList = document.getElementsByClassName('searchBtnLog')
			parentList = [...parentList]
			parentList.forEach(item => {
				if (item.contains(e.target)) {
					let id = item.getAttribute('data-id')
					this.$btnSysLog(id, 0)
				}
			});
		}
	},
};
</script>

<style lang="scss">
@import "@/style/common.scss";

// /deep/.ivu-select-dropdown{
// 	background: red;
// 	}
body,
html {
	margin: 0;
	padding: 0;
	height: 100vh;
	width: 100vw;
	user-select: none;
	background: #fff;
}

::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 15px;
	/*高宽分别对应横竖滚动条的尺寸*/
	height: 15px;
	cursor: pointer;
}

::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	width: 15px;
	// border-radius: 2px;
	background: rgba(0, 0, 0, 0.2);
	cursor: pointer;
}

::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	// border-radius: 10px;
	background: transparent;
	cursor: pointer;
}

.scroll-wrapper {
	width: 100%;
	overflow-x: auto;
	height: 22px;
	white-space: nowrap;
	display: flex;
	-webkit-overflow-scrolling: touch;
}

.scroll-wrapper span {
	display: block;
	padding: 0 4px;
	margin: 0 10px;
	height: 20px;
	line-height: 20px;
	font-size: 14px;
	border: 1px solid #3884ff;
	border-radius: 20px;
	color: #3884ff;
}

#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	min-width: 1400px;
	margin: 0;
	color: #333333;
	padding: 0;
	height: 100%;
	position: relative;
}

.expire-notice-text {
	position: fixed;
	top: 38px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 9999;
	color: #ff0000;
	font-size: 16px;
	font-weight: 500;
	text-align: center;
	padding: 10px 20px;
	// background-color: rgba(255, 255, 255, 0.9);
	border-radius: 4px;
	// box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}





.ivu-notice {
	top: 7% !important;
	left: 50%;
	transform: translate(-50%) !important;
	width: 500px !important;
	z-index: 9999 !important;

	.ivu-notice-notice {
		// background: transparent;
		padding: 23px !important;
		background-color: #00b6ff !important;

		.ivu-notice-icon {
			color: #ffd130 !important;
			font-size: 0px !important;
		}

		.ivu-icon-ios-close {
			color: white;
			font-size: 30px !important;
			font-weight: 900 !important;
		}

		.ivu-notice-title {
			margin-left: 16px !important;
			color: white !important;
		}
	}

	.ivu-notice-desc {
		color: white !important;

		letter-spacing: 1px !important;
		line-height: 22px !important;
		font-size: 14px !important;
	}

	.ivu-notice-content-with-icon {
		letter-spacing: 1px !important;
		line-height: 22px !important;
		font-size: 14px !important;
		color: white !important;
		margin-left: 16px !important;
	}

	.ivu-notice-title {
		letter-spacing: 1px !important;
		line-height: 20px !important;
		font-size: 16px !important;
		font-weight: 900 !important;
	}
}

.navBox {
	position: relative;
	width: 100%;
	height: auto;
	z-index: 1024;

	.openNav,
	.closeNav {
		position: absolute;
		width: 42px;
		height: 16px;
		right: 17px;
		bottom: -1px;
		z-index: 2048;
		cursor: pointer;
	}

	.openNav {
		bottom: -15px;
		transform: rotate(180deg);
	}
}

.nav {
	width: 100%;
	height: 74px;
	// background: rgba(30, 46, 84, 1);
	background: #D4E6F7;
	// box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.05);
	@include flex-center;
	justify-content: space-between;
	// overflow: hidden;
	transition: 0.5s;

	&.fullScreen {
		height: 0px;
	}

	.logo {
		width: 240px;
		height: 74px;
		cursor: pointer;
		margin-left: 25px;
	}

	.center-box {
		width: 100%;
		padding-left: 54px;
		font-family: Alimama ShuHeiTi;
		font-weight: bold;
		font-size: 36px;
		color: #002C63;
		// cursor: pointer;
	}

	.tabList {
		width: calc(100% - 600px);
		display: flex;
		height: 100%;

		// margin: 0 15px;
		.tabItem {
			// flex: 1;
			height: 100%;
			text-align: center;
			// overflow: hidden;
			position: relative;
			// color: #fff;
			// transition: 0.3s;
			margin-left: 60px;
			cursor: pointer;
			font-size: 18px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #262626;

			.icon,
			.iconB {
				display: block;
				width: 20px;
				top: calc(50% - 24px);
				left: calc(50% - 10px);
				position: absolute;
			}

			.iconB {
				display: none;
			}

			.name {
				width: 100%;
				// top: calc(50% + 5px);
				// position: absolute;

				line-height: 74px;
				white-space: nowrap;
			}

			&:hover,
			&.active {
				border-bottom: 2px solid #045AFC;
				// background: #e7f0fc;
				font-weight: 800;
				color: #0073FA;

				.iconB {
					display: block;
				}

				.icon {
					display: none;
				}
			}

		}
	}

	.tabItem-box {
		position: absolute;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		width: 155px;
		background: #FFFFFF;
		box-shadow: 0px 0px 10px 1px rgba(0, 119, 255, 0.45);
		// opacity: 0.64;
		padding: 4px 0;
		text-align: left;

		.tabItem-box-item {
			height: 32px;
			width: 100%;
			line-height: 32px;
			padding-left: 14px;
			color: #262626;

			&:hover {
				background: #0073FA;
				color: #FFFFFF;
			}

		}

	}

	.rightContent {
		width: 300px;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		white-space: norwap;
		font-size: 18px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #262626;
		justify-content: flex-end;

		.line {
			width: 1px;
			height: 40px;
			background: rgba(0, 0, 0, 0.15);
		}

		.officialWebsite {
			// @include flex-center;
			margin-left: 40px;
			// margin: 0 40px;
			white-space: nowrap;
			cursor: pointer;

			a {
				color: #262626;
			}

			&:hover {
				color: #262626;
			}
		}

		.top,
		.bottom {
			height: 45%;
			display: flex;
			align-items: center;
			white-space: norwap;
			// width: 100%;
		}


		.tradingPlatform {
			@include flex-center;
			color: #fff;
			margin-right: 40px;
			white-space: nowrap;
			cursor: pointer;

			&:hover {
				color: #eee;
			}

			img {
				margin-right: 6px;
			}
		}

		.infoTips {
			position: relative;
			cursor: pointer;
			margin-left: 43px;
			margin-right: 26px;

			img {
				display: block;
				width: 14px;
				height: 16px;
			}

			.infoNumber {
				position: absolute;
				width: 14px;
				height: 14px;
				background: rgba(245, 44, 43, 1);
				border-radius: 50%;
				font-size: 12px;
				font-family: PingFangSC-Regular-, PingFangSC-Regular;
				font-weight: normal;
				color: #FFFFFF;
				// color: #ffffff;
				top: -9px;
				right: -9px;
				@include flex-center;
			}

			.bigNum {
				height: 16px;
				width: 28px;
				border-radius: 25px;
				top: -9px;
				right: -24px;
			}
		}

		.manage {
			@include flex-center;
			font-size: 14px;
			// color: #ffffff;
			font-family: ArialMT-, ArialMT;
			justify-content: left;
			cursor: pointer;
			white-space: nowrap;
			width: 140px;

			.manageIcon {
				width: 36px;
				height: 36px;
				border-radius: 50%;
				margin-right: 8px;
				// background: #000;
			}

			.downIcon {
				margin-left: 6px;
			}
		}

		.fullScreen {
			cursor: pointer;
			position: absolute;
			right: 27px;
			bottom: 18px;
		}

		.logoA {
			white-space: nowrap;
			transform: translate(0px, 0px);
			display: flex;
			align-items: center;
			// color: #fff;
		}

		.logo2 {
			width: 20px;
			height: 20px;
			margin-right: 3px;
		}
	}
}

.navChildren {
	position: absolute;
	top: 80px;
	left: 0;
	width: 100%;
	height: 220px;
	background: rgba(231, 240, 252, 1);
	box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
	z-index: 9999;

	.childrenBox {
		margin: 20px auto 0;
		width: 740px;
		display: grid;
		grid-template-columns: repeat(3, 160px);
		grid-template-rows: repeat(2, 80px);
		grid-row-gap: 20px;
		grid-column-gap: 130px;

		.childrenRoute {
			width: 180px;
			height: 80px;
			@include flex;
			cursor: pointer;

			.icon,
			.iconB {
				display: block;
				width: 24px;
				height: 24px;
				margin-right: 10px;
			}

			.iconB {
				display: none;
			}

			color: #1e2e54;

			&:hover {
				color: #1562d6;

				.iconB {
					display: block;
				}

				.icon {
					display: none;
				}
			}
		}
	}
}

.content {
	display: flex;
	transition: 0.5s;
	width: 100%;
	height: 100%;
	min-height: 100vh;
	margin: 0 auto;
	display: flex;
	margin-top: -1px;
	background: url("~@/assets/login/login_bg_all.png");
	background-size: 100% 100%;
}

@media screen and (max-width: 1600px) {
	.nav .tabList .tabItem {
		font-size: 14px;
		margin-left: 40px;
	}

	.nav .rightContent .officialWebsite {
		// display: none;
		font-size: 14px;

	}
}

@media screen and (max-width: 1800px) {
	.line {
		display: none;
	}

	.rightContent .officialWebsite {
		// display: none;
		// font-size: 14px;
	}

	.rightContent {
		width: 200px;
	}
}

.ivu-table-fixed {
	margin-bottom: 10px !important;
	height: auto !important;
}
</style>
<style>
.input_box {
	background: #F5F6FC !important;
	border: 0 !important;

}

.el-input__inner {

	background: #F5F6FC !important;
	border: 0 !important;
}

.ivu-form-item {
	margin-bottom: 20px !important;
}

.ivu-select-selection {
	background: #F5F6FC !important;
	border: 0 !important;

}

.ivu-input {
	background: #F5F6FC !important;
	border: 0 !important;


}

.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #045AFC !important;

}


/* .ivu-table-stripe .ivu-table-body tr:nth-child(2n-1) td, .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n-1) td {
background: #F5F6FC  ;

} */
.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
.ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
	/* background: #F5F6FC !important; */
}

/* .ivu-table-stripe .ivu-table-body tr:nth-child(2n) td, .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
background: #F5F6FC !important ;

} */

/* .ivu-table-row-hover {
  background: red !important;
} */



.ivu-table td,
.ivu-table th {
	border: 0 !important;
	height: 70px;
}


/* .ivu-table th {
	background: transparent ;
} */



/* .ivu-table-body tr:hover  {
	color: #045AFC !important;
	background: #FFFFFF !important;
	border: 1px solid rgba(4, 90, 252, 0.66) !important;
} */


ivu-table-row-highlight td,
.ivu-table-stripe .ivu-table-body tr.ivu-table-row-highlight:nth-child(2n) td,
.ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-highlight:nth-child(2n) td,
tr.ivu-table-row-highlight.ivu-table-row-hover td {
	background-color: red;
}

/* tr.ivu-table-row-hover td{
background: #FFFFFF !important;
box-shadow: 0px 4px 10px 0px rgba(4,90,252,0.36);
border: 1px solid rgba(4,90,252,0.66);
border-left: none;
border-right: none;
} */
tr.ivu-table-row {
	border: 1px solid rgba(4, 90, 252, 0.66) !important;

}


/* .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: red !important;
	background: #FFFFFF !important;
box-shadow: 0px 4px 10px 0px rgba(4,90,252,0.36);
border: 1px solid rgba(4,90,252,0.66);
border-left: none;
border-right: none;
} */




.el-table__row :hover {
	/* background: red !important; */
}
</style>
<style>
.map-info-box-1 {
	position: relative;
	cursor: pointer;
	background-color: #D3E4F4;
	border: 1px solid #D3E4F4;
	padding: 1px 10px;
	white-space: nowrap;
	font: 18px / 36px arial, sans-serif;
	z-index: 13375666;
	color: #045AFC;
	border-radius: 5px;
	height: 40px;
	user-select: none;




}

.map-info-box-1:hover {
	background-color: #7AB4F4;
	border: 1px solid #7AB4F4;
	color: #fff;
}

.map-info-box-1:hover:after {

	border-top: 9px solid #7AB4F4;

}

.map-info-box-1:after {
	position: absolute;
	background: transparent;
	top: 100%;
	left: calc(50% - 11px);
	width: 25px;
	height: 30px;
	content: '';
	box-sizing: border-box;
	border-top: 9px solid #D3E4F4;
	border-left: 14px solid transparent;
	border-right: 11px solid transparent;
	background-position: -20px bottom;
	background-origin: border-box;

}

.map-info-yellow {
	background-color: #7AB4F4;
	border: 1px solid #7AB4F4;
	color: #fff;
}

.map-info-yellow:after {
	border-top: 9px solid #7AB4F4;
}


.admin-mark-info-box {
	width: 84px;
	height: 84px;
	line-height: 1;
	font-size: 14px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	border: 1px solid transparent;
	border-radius: 50%;
	overflow: hidden;
	text-align: center;
	font-family: PingFangSC-Semibold;
	color: #fff;
	background: #018BFF;

}

.admin-mark-info-box:hover {
	width: 110px;
	height: 110px;
	background-color: #7AB4F4;
	border: 1px solid #7AB4F4;

}
</style>
